/**
 * @fileoverview Consultas ao desenho do fluxo (nós e ligações) que mais de uma
 * parte do editor faz.
 */

/**
 * O node ligado à entrada deste (o de cima): de onde o "Enviar Mensagem" tira
 * a conexão ("Disparo em massa" ou "Status da OS"). Com mais de uma ligação
 * chegando, vale a primeira.
 */
export const upstreamNode = (nodes, edges, nodeId) => {
  const edge = (edges || []).find((e) => e.target === nodeId);
  return edge ? (nodes || []).find((n) => n.id === edge.source) || null : null;
};
